// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__31cqf","label":"Section_label__1-zfM","contentWrap":"Section_contentWrap__1QQ5K","footer":"Section_footer__Ijlxz","footerInner":"Section_footerInner__Ia55Y"};